import React from "react";
import { Container, Row, Col } from "react-bootstrap";
// import heroBg from "../../assets/images/bg/community1.jpg";
import whyright from "../../assets/images/insurance/whyright.png";
import ccLogo from "../../assets/images/insurance/Union.png";
import ewLogo from "../../assets/images/insurance/elevate-wellness-logo.png";
import "./why.scss";
import parse from "html-react-parser";

const Why = ({ data }) => {
  return (
    <section className="section why-section">
      <Container className="">
        <Row className="">
          <Col md={6} sm={12} className="why-content d-flex flex-column mb-md-0 mb-5">
            <Row className=" text-md-start text-center">
              <Col xl={8} lg={10} xs={12}>
                <h1>{parse(data?.why_join_title || "")}</h1>
                <p className="text-xxl">{parse(data?.why_join_sub_title || "" || "")}</p>
              </Col>
            </Row>

            <div className="mt-auto d-flex align-items-center justify-content-md-start justify-content-center gap-5">
              <img src={ccLogo} alt="" className="ccLogo" />
              <h1>+</h1>
              <img src={ewLogo} alt="" className="ewLogo" />
            </div>
          </Col>

          <Col md={6} sm={12} className="">
            <div className="why-right mx-auto">
              <div className="why-video position-relative overflow-hidden">
                <img src={data?.why_join_image || whyright} alt="" />
                <span className="video-border" style={{ background: "linear-gradient(180deg, #8aece1 0%, rgba(255, 115, 27, 0) 100%), #8aece1" }}></span>
              </div>
              <p className="text-md">{data?.why_join_details || ""}</p>

              {/* <div className="whyVideos"> */}
                {/* <li> */}
                    {/* <span
                      className="videoBg"
                      style={{
                        background: "linear-gradient(180deg, rgba(238, 186, 84, 0) 0%, #8aece1 100%)",
                      }}
                    ></span> */}
                {/* </li> */}
              {/* </div> */}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Why;
